module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex flex-column position-relative"
  }, [(_vm.showInvoiceModal) ? _c('invoice-modal', {
    on: {
      "toggleInvoiceModal": _vm.toggleInvoiceModal,
      "invoiceCancelled": _vm.invoiceCancelled
    }
  }) : _vm._e(), _vm._v(" "), _c('navigator'), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 flexGrow1 overflow-auto"
  }, [_c('filters'), _vm._v(" "), _c('invoice-list', {
    on: {
      "selectInvoice": _vm.invoiceSelected
    }
  })], 1)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-642ce5c6", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-642ce5c6"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/invoices/Invoices.vue
// module id = 1846
// module chunks = 0